import React, { useState } from 'react';
import { Container, Grid, Card, CardContent, Typography, TextField, Box, AppBar, Toolbar, IconButton } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import HandymanIcon from '@mui/icons-material/Handyman';
import { tools } from './tools';
import './App.css';

function App() {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredTools = tools.map(category => ({
    ...category,
    items: category.items.filter(tool =>
      tool.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      tool.description.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(category => category.items.length > 0);

  return (
    <div className="App">
      <AppBar position="static" sx={{ backgroundColor: '#1a1a1a' }}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: '#ffffff', textAlign: 'left', pl: 2, display: 'flex', alignItems: 'center' }}>
            <HandymanIcon sx={{ mr: 1 }} />
            工具集
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton sx={{ color: '#ffffff' }}>
              <SearchIcon />
            </IconButton>
            <TextField
              placeholder="搜索工具..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              variant="outlined"
              size="small"
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: 1,
                '& .MuiOutlinedInput-root': {
                  color: '#ffffff',
                  '& fieldset': {
                    borderColor: 'rgba(255, 255, 255, 0.2)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(255, 255, 255, 0.3)',
                  },
                },
                '& .MuiInputBase-input::placeholder': {
                  color: 'rgba(255, 255, 255, 0.5)',
                },
              }}
            />
          </Box>
        </Toolbar>
      </AppBar>
      <Container sx={{ mt: 4, mb: 4, backgroundColor: '#f8f9fa', borderRadius: 2, boxShadow: '0 0 20px rgba(0,0,0,0.05)', p: 3 }}>
        {filteredTools.map((category, index) => {
          const themeColor = category.color || '#1976d2';
          
          return (
            <Box key={index} sx={{ mb: 4 }}>
              <AppBar position="static" sx={{ backgroundColor: themeColor, mb: 2, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                <Toolbar variant="dense">
                  <Typography variant="h6" sx={{ flexGrow: 1, textAlign: 'left', pl: 1 }}>
                    {category.category}
                  </Typography>
                </Toolbar>
              </AppBar>
              <Grid container spacing={2}>
                {category.items.map((tool, toolIndex) => (
                  <Grid item xs={6} sm={4} md={2.4} key={toolIndex}>
                    <Card
                      component="a"
                      href={tool.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'all 0.3s ease-in-out',
                        borderRadius: 2,
                        overflow: 'hidden',
                        backgroundColor: `${themeColor}15`,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                        '&:hover': {
                          transform: 'translateY(-3px)',
                          boxShadow: `0 8px 16px ${themeColor}35`,
                          textDecoration: 'none'
                        },
                        textDecoration: 'none',
                        color: '#2c3e50'
                      }}
                    >
                      <Box sx={{
                        position: 'relative',
                        paddingTop: '52.25%',
                        backgroundColor: '#f8f9fa',
                        overflow: 'hidden',
                        border: `2px solid ${themeColor}15`,
                        borderRadius: '8px 8px 0 0'
                      }}>
                        <img
                          src={`https://api.thumbalizr.com/?api_key=rdWx4FRn2ZTYvf2OcCjEoz5Iy4STHG&url=${encodeURIComponent(tool.url)}&width=200`}
                          alt={tool.name}
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                          loading="lazy"
                        />
                      </Box>
                      <CardContent sx={{ flexGrow: 1, p: 1.5 }}>
                        <Typography variant="subtitle1" component="div" sx={{ fontWeight: 600, fontSize: '1rem', color: '#2c3e50', mb: 0.5 }}>
                          {tool.name}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#666666', fontSize: '0.85rem', lineHeight: 1.4 }}>
                          {tool.description}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          );
        })}
      </Container>
    </div>
  );
}

export default App;
